module.exports = __webpack_public_path__ + "img/life-game-screenshot.4fb633f3.png";